const HEX3 = /^#[0-9a-f]{3}$/i;
const HEX6 = /^#[0-9a-f]{6}$/i;

export function expandShortHex(hex?: string | null): string | undefined {
  if (!hex) return undefined;
  const h = hex.trim().toLowerCase();
  if (HEX3.test(h)) {
    const [r, g, b] = [h[1], h[2], h[3]];
    return `#${r}${r}${g}${g}${b}${b}`;
  }
  if (HEX6.test(h)) return h;
  return undefined;
}

export function hexToRgb(hex: string): { r: number; g: number; b: number } | null {
  const h = expandShortHex(hex);
  if (!h) return null;
  const r = parseInt(h.slice(1, 3), 16);
  const g = parseInt(h.slice(3, 5), 16);
  const b = parseInt(h.slice(5, 7), 16);
  return { r, g, b };
}

export function getContrastingText(hex?: string): 'black' | 'white' {
  const rgb = hexToRgb(hex ?? '');
  if (!rgb) return 'black';
  const srgb = ['r', 'g', 'b'].map((k) => {
    const v = (rgb as any)[k] / 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  });
  const L = 0.2126 * srgb[0] + 0.7152 * srgb[1] + 0.0722 * srgb[2];
  return L > 0.5 ? 'black' : 'white';
}
